<template>
  <form>
    <fieldset class="fieldset">
      <legend>{{ 'Filter'|t }}</legend>
      <div class="expanded row">
        <div class="column">
          <div class="expanded row">
            <div class="column shrink"><label for="domain" class="middle">{{ 'Domain'|t }}</label></div>
            <div class="column"><input id="domain" class="text-center" type="text" v-model="filter.domain"></div>
          </div>
        </div>
<!--        <div class="column">-->
<!--          <div class="expanded row">-->
<!--            <div class="column shrink"><label for="author" class="middle">{{ 'Author'|t }}</label></div>-->
<!--            <div class="column">-->
<!--              <AutoCompleteContact v-model="filter.author" :value="filter.author" name="author" id="author"></AutoCompleteContact>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="column">-->
<!--          <div class="expanded row">-->
<!--            <div class="column shrink"><label for="owner" class="middle">{{ 'Owner'|t }}</label></div>-->
<!--            <div class="column">-->
<!--              <AutoCompleteContact v-model="filter.owner" :value="filter.owner" name="owner" id="owner"></AutoCompleteContact>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="small-3 columns">
          <div class="expanded button-group">
            <button class="hollow success button" @click.prevent="submitForm()">{{ 'Submit'|t }}</button>
            <button class="hollow primary button" @click.prevent="clearForm()">{{ 'Clear'|t }}</button>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
</template>
<script>
  import AutoCompleteContact from '@/components/AutoCompleteContact';

  export default {
    name: 'TransferCollectionFilterForm',
    components: { AutoCompleteContact },
    props: {
      value: {
        type: Object,
        default: () => {
          return {
            domain: "",
            // author: "",
            // owner: ""
          }
        }
      }
    },
    data() {
      return {
        filter: {
          domain: this.value.domain || "",
          // author: this.value.author || "",
          // owner: this.value.owner || ""
        }
      }
    },
    methods: {
      submitForm() {
        this.$emit('submit', this.filter)
      },
      clearForm() {
        this.filter = {
          domain: "",
          // author: "",
          // owner: ""
        };
        this.$emit('reset', this.filter)
      }
    },
    watch: {
      watch: {
        filter: {
          deep: true,
          handler(to) {
            this.$emit('change', to)
          }
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/TransferCollectionFilterForm.vue